import React, { useEffect, useState } from "react";

const AdBanner = () => {
  const [injectedExisting, setInjectedExisting] = useState({ top: false, bottom: false });

  useEffect(() => {
  console.log('AdBanner: mounted');
    // Helper to inject an ad into a target element.
    const injectAd = (target, key, invokeUrl, w, h) => {
  if (!target) return false;
      // If already injected successfully, nothing to do
      if (target.dataset.adInjected === 'true') return true;
      // If an injection attempt is already in progress, skip for now
      if (target.dataset.adAttempted === 'true') {
        console.log('AdBanner: injection already attempted for this target; skipping');
        return false;
      }
      // mark that we're attempting an injection so we don't race
      target.dataset.adAttempted = 'true';

      // set global options explicitly
      const opts = {
        key,
        format: 'iframe',
        height: h,
        width: w,
        params: {}
      };

      const setup = document.createElement('script');
      setup.type = 'text/javascript';
      setup.text = `window.atOptions = ${JSON.stringify(opts)};`;

      const invoke = document.createElement('script');
      invoke.src = invokeUrl;
      invoke.async = true;

  // Small visible status badge to help troubleshooting on deployed site
  const badge = document.createElement('div');
  // ensure badge is visible above fixed game layers
  badge.style.cssText = 'font-size:12px;background:#222;color:#fff;padding:4px 6px;border-radius:4px;position:relative;display:inline-block;margin-bottom:6px;z-index:9999';
      badge.textContent = 'Ad: loading...';
      // Insert badge first so it's visible before scripts run
      target.appendChild(badge);

      // wire up load/error handlers
      let failTimeout = null;
  const cleanupAttempt = (succeeded) => {
        // clear timeout if any
        if (failTimeout) {
          clearTimeout(failTimeout);
          failTimeout = null;
        }
        // if failed, remove created elements and allow future retries
        if (!succeeded) {
          try {
            if (badge && badge.parentNode === target) target.removeChild(badge);
            if (setup && setup.parentNode === target) target.removeChild(setup);
            if (invoke && invoke.parentNode === target) target.removeChild(invoke);
          } catch (err) {
            // ignore
          }
          delete target.dataset.adAttempted;
          if (target._adElements) delete target._adElements;
          console.warn(`AdBanner: cleaned up failed injection attempt for key=${key}`);
          return;
        }
        // succeeded: mark injected
        target.dataset.adInjected = 'true';
        // store failTimeout as string for backwards compatibility
        target.dataset.adFailTimeout = '0';
  console.log(`AdBanner: injected ad key=${key} into`, target);
      };

      invoke.onload = () => {
        badge.textContent = 'Ad: loaded';
        badge.style.background = '#2a7f2a';
        console.log(`AdBanner: invoke script loaded for key=${key}`);
        cleanupAttempt(true);
      };
      invoke.onerror = (e) => {
        badge.textContent = 'Ad: failed';
        badge.style.background = '#9b2a2a';
        console.error(`AdBanner: failed to load invoke script for key=${key}`, e);
        cleanupAttempt(false);
      };

      target.appendChild(setup);
      target.appendChild(invoke);
      // safety timeout: if still loading after 10s mark as failed and cleanup so future retries can occur
      failTimeout = setTimeout(() => {
        if (badge.textContent === 'Ad: loading...') {
          badge.textContent = 'Ad: timeout';
          badge.style.background = '#b36b00';
          console.warn(`AdBanner: ad load timeout for key=${key}`);
          cleanupAttempt(false);
        }
      }, 10000);

      // keep references for cleanup on unmount
      target._adElements = { setup, invoke, badge, failTimeoutRef: () => failTimeout };
      return true;
    };

    // Try to inject now; if not present, observe DOM for the containers (top and bottom)
    // Only attempt injection into the left-down slot (game uses .ad-space-left-down).
    const tryInject = () => {
      const bottomTarget = document.getElementById('ad-bottom-slot') || document.querySelector('.ad-space-left-down');
      const bottomOk = injectAd(bottomTarget, '7d8c58a2124fa18300476cff3fe31a7f', 'https://wailsilence.com/7d8c58a2124fa18300476cff3fe31a7f/invoke.js', 300, 250);
      return bottomOk;
    };

  let injectedBottom = false;
    // If an existing bottom container exists, try injecting into it and mark so we don't render local slot
  const existingBottom = document.querySelector('.ad-space-left-down');
  if (existingBottom) {
      existingBottom.style.width = '300px';
      existingBottom.style.height = '300px';
      existingBottom.style.minWidth = '300px';
      existingBottom.style.minHeight = '300px';
      existingBottom.style.display = existingBottom.style.display || 'flex';
      existingBottom.style.alignItems = 'center';
      existingBottom.style.justifyContent = 'center';
      existingBottom.style.overflow = 'hidden';

      const bottomOk = injectAd(existingBottom, '7d8c58a2124fa18300476cff3fe31a7f', 'https://wailsilence.com/7d8c58a2124fa18300476cff3fe31a7f/invoke.js', 300, 250);
      injectedBottom = bottomOk;
      if (injectedBottom) {
        try { setInjectedExisting(prev => ({ ...prev, bottom: true })); } catch (e) { }
      }
    }

    if (injectedBottom) {
      // injected into existing bottom container; no need to observe
      return () => {};
    }

    // If we get here, at least one target was missing. Observe for additions.
    const observer = new MutationObserver((mutations, obs) => {
      if (tryInject()) {
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Try immediately in case the local slot was rendered already (no DOM mutation will fire)
    if (tryInject()) {
      observer.disconnect();
    }

    // cleanup on unmount: disconnect observer and remove any created ad elements we stored
  return () => {
      observer.disconnect();
      const cleanupTarget = (selOrId) => {
        const t = document.getElementById(selOrId) || document.querySelector(selOrId);
        if (!t) return;
        const stored = t._adElements;
        try {
          if (stored) {
            if (stored.setup && stored.setup.parentNode === t) t.removeChild(stored.setup);
            if (stored.invoke && stored.invoke.parentNode === t) t.removeChild(stored.invoke);
            if (stored.badge && stored.badge.parentNode === t) t.removeChild(stored.badge);
            const to = typeof stored.failTimeoutRef === 'function' ? stored.failTimeoutRef() : null;
            if (to) clearTimeout(to);
            delete t._adElements;
          }
        } catch (e) {
          // ignore
        }
        // also remove attempted flag so future mounts can try again
        try { delete t.dataset.adAttempted; } catch (e) { }
      };

  // Only clean up left-down slot elements
  cleanupTarget('ad-bottom-slot');
  cleanupTarget('#ad-bottom-slot');
  cleanupTarget('.ad-space-left-down');
    };
  }, []);

    // Render only the bottom local slot if we did not inject into an existing bottom container
    const showBottomLocal = !injectedExisting.bottom;

    return (
      <div style={{ position: 'relative', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 20, alignSelf: 'flex-start', flexShrink: 0 }}>
        {showBottomLocal && (
          <div
            id="ad-bottom-slot"
            className="ad-space-left-down"
            style={{ width: 300, height: 300, minWidth: 300, minHeight: 300, marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}
          />
        )}
  {/* Debug overlay removed per user request (no fixed corner div) */}
      </div>
    );
};

export default AdBanner;
